import { ChangeEvent } from 'react';

import { CircularProgress, TextField, useTheme } from '@material-ui/core';

import { RiCheckboxCircleFill as CheckCircleIcon } from '@remixicon/react';

import { FormFieldsBox } from '@spotify/confidence-core-react';

import type { CreateAccountFormState } from './hooks';

type WorkspaceNameFieldsProps = {
  form: CreateAccountFormState;
};

export const WorkspaceNameFields = ({ form }: WorkspaceNameFieldsProps) => {
  const theme = useTheme();
  const {
    accountDetails,
    handleDisplayNameChange,
    handleDisplayNameBlur,
    validDisplayName,
    helperText,
    loginIdAvailable,
    loginIdError,
    loginIdConfirmedAvailable,
    isCheckingAvailability,
  } = form;

  return (
    <FormFieldsBox spacing={2}>
      <TextField
        variant="outlined"
        label="Workspace name"
        placeholder="For example My Company"
        value={accountDetails.displayName}
        helperText={helperText}
        error={!validDisplayName || !loginIdAvailable || !!loginIdError}
        required
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          handleDisplayNameChange(e.target.value)
        }
        onBlur={handleDisplayNameBlur}
        InputProps={{
          endAdornment: isCheckingAvailability ? (
            <CircularProgress size="1rem" />
          ) : (
            loginIdConfirmedAvailable && (
              <CheckCircleIcon size={20} color={theme.palette.success.main} />
            )
          ),
        }}
        fullWidth
      />
    </FormFieldsBox>
  );
};
